module.exports = __webpack_public_path__ + "static/DMSans-Italic-652c8efcbe65e82cb1e59351b2690041.woff";